const preventDefault = (event: React.FormEvent<HTMLFormElement>, func: () => void) => {
  event.preventDefault();
  func();
  return false;
};

export {
  preventDefault
};
